import { Button as NikeButton, Loading } from '@nike/frame-component-library';
import PropTypes from 'prop-types';
import React from 'react';

const ButtonBlack = ({
  className, fullWidth, id, isDisabled, isLoading, label, onAway, onClick, onHover, showDisabledMessage, errorMessage, beforeSlot
}) => (
  isLoading
    ? <Loading />
    : (
      <>
        <NikeButton
          className={`ncss-btn-primary-dark bg-black border ${className} ${fullWidth && 'u-full-width'}`}
          id={id}
          isDisabled={isDisabled}
          style={{ flexDirection: 'row', verticalAlign: 'middle' }}
          onClick={onClick}
          onMouseLeave={onAway}
          onMouseOver={onHover}
        >
          <span style={{ color: '#FFFFFF', display: 'flex' }}>
            {beforeSlot || <></>}{label}
          </span>
        </NikeButton>
        {isDisabled && showDisabledMessage && <p className="text-color-error body-4 mt1-sm">Please resolve the remaining errors.</p>}
        {errorMessage && <p className="text-color-error body-6 mt1-sm">{errorMessage}</p>}
      </>
    )
);

ButtonBlack.defaultProps = {
  beforeSlot: null,
  className: 'mt10-sm border',
  errorMessage: '',
  fullWidth: false,
  id: '',
  isDisabled: false,
  isLoading: false,
  label: 'Submit',
  onAway: () => {},
  onHover: () => {},
  showDisabledMessage: true,
};

ButtonBlack.propTypes = {
  beforeSlot: PropTypes.node,
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  label: PropTypes.string,
  onAway: PropTypes.func,
  onClick: PropTypes.func.isRequired,
  onHover: PropTypes.func,
  showDisabledMessage: PropTypes.bool,
};

export default ButtonBlack;
